import {
    DateFormatTemplate,
    formatAsLocalTimezone
} from '@utils/date-format';
import moment from 'moment';

export const getLocalTimezone = (): string => moment.tz.guess();
export const getCurrentISOTimestamp = (): string => moment().utc().toISOString();
export const matchesTodaysLocalDate = (dateToCheck: moment.MomentInput): boolean => {
    return moment(dateToCheck).isSame(moment(), 'date');
};
export const isTodaysLocalFormattedDate = (
    formattedDateString: string,
    dateFormat: DateFormatTemplate = DateFormatTemplate.MonthFirstCalendarDate
): boolean => {
    return formattedDateString === formatAsLocalTimezone(
        getCurrentISOTimestamp(),
        dateFormat
    );
};
export const getTomorrowISOTimestamp = (): string => (
    moment()
        .startOf('day')
        .add(1, 'day')
        .toISOString()
);
export const getTodayISOTimestamp = (): string => (
    moment()
        .startOf('day')
        .toISOString()
);



// WEBPACK FOOTER //
// ./src/utils/date-query.ts